<script lang="ts" setup>
import { computed, onMounted, ref } from '#imports';
import { register } from 'swiper/element';
import { Autoplay, Pagination } from 'swiper/modules';
import { getHomeCarouselNew } from '~/api/oj/banner';
import type { SliderVO } from '~/types/auto/oj';
import { PUBLIC_CDN } from '~/utils/environment';

register();

type RequiredSliderVO = Required<SliderVO>;
const list = ref([] as RequiredSliderVO[]);
const swiperRef = ref();

const paginationConfig = computed(() => {
  return list.value.length > 1
    ? {
        clickable: true,
      }
    : false;
});

const renderList = computed(() => {
  return list.value.map((item) => {
    return {
      ...item,
      event: { banner_id: `${item.id}` },
    };
  });
});

function initDataDefault() {
  list.value = [
    {
      id: -1,
      img: `${PUBLIC_CDN}/code-community/markdownImg/prod/9a9bf76b4c7046d3afacca878f041b2f.jpg`,
    },
  ] as RequiredSliderVO[];
}

function initData() {
  return getHomeCarouselNew()
    .then((res) => {
      if (res?.length) {
        list.value = res as RequiredSliderVO[];
      } else {
        initDataDefault();
      }
    })
    .catch(() => {
      initDataDefault();
    });
}

function initSwiper() {
  const swiperEl = swiperRef.value;

  const params = {
    modules: [Autoplay, Pagination],
    slidesPerView: 1,
    speed: 500, // 切换速度
    autoplay: {
      delay: 3000, // 停留时间
      pauseOnMouseEnter: true,
    },
  };

  Object.assign(swiperEl, params);

  swiperEl.initialize();
}

onMounted(() => {
  initData().then(() => {
    initSwiper();
  });
});
</script>

<template>
  <div class="relative overflow-hidden rounded bg-white">
    <div
      v-if="list.length === 0"
      class="flex h-[174px] items-center justify-center p-3"
    >
      <a-skeleton />
    </div>
    <swiper-container
      v-else
      ref="swiperRef"
      :init="false"
      :pagination="paginationConfig"
    >
      <swiper-slide v-for="item in renderList" :key="item.id" class="h-[174px]">
        <template v-if="item.url">
          <NuxtLink
            v-login="item.forceLogin"
            v-track:newoj_homepage_Banner_show="item.event"
            v-track:newoj_homepage_Banner_click.click="item.event"
            :to="item.url"
            :target="item.target ? '_blank' : '_self'"
          >
            <img
              class="h-full w-full object-cover"
              :src="item.img"
              alt="banner"
            />
          </NuxtLink>
        </template>
        <template v-else>
          <img
            v-track:newoj_homepage_Banner_show="item.event"
            class="h-full w-full object-cover"
            :src="item.img"
            alt="banner"
          />
        </template>
      </swiper-slide>
    </swiper-container>
  </div>
</template>

<style scoped>
swiper-container::part(pagination) {
  position: absolute;
  bottom: 24px;
  left: 22px;
  z-index: 10;
}
swiper-container::part(bullet) {
  display: inline-block;
  width: 12px;
  height: 2px;
  margin: 0 2px;
  background: rgba(255, 255, 255, 0.2);
  cursor: pointer;
}
swiper-container::part(bullet-active) {
  display: inline-block;
  width: 12px;
  height: 2px;
  margin: 0 2px;
  background: #a1a1aa;
  cursor: pointer;
}
</style>
